import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  InputNumber,
  Checkbox,
  message,
} from "antd";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { UploadOutlined, StarOutlined } from "@ant-design/icons";
import config from "../../../config";
import { professionalAction } from "../../../_actions/professional.actions";
import Compressor from "compressorjs";
import { authHeader } from "../../../_helpers";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalService } from "../../../_services";
import { AccusedImageCropModal } from "./AccusedImageCropModal";

const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const ArrestForm = forwardRef((props, ref) => {
  const baseUrl = config.apiGateway.baseUrl;
  const [form] = Form.useForm();
  const [progress, setProgress] = useState(0);
  const [fileList, SetfileList] = useState([]);
  const [sadyasthiti, setSadyasthiti] = useState([]);
  const [sadysthitiValue, setSadysthitiValue] = useState();
  const [districts, setDistricts] = useState([]);
  const [selectDistricts, setSelectDistricts] = useState();
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState("");
  const [cropOriginalFile, setCropOriginalFile] = useState(null);
  const cropResolveRef = useRef(null);
  const { t } = useContext(LanguageContext);
  const user = JSON.parse(localStorage.getItem("user"));

  const getDistrictName = () => {
    if (districts && districts.length) {
      const found = districts.find(
        (o) => String(o.id) === String(user.districtId),
      );
      if (found) {
        setSelectDistricts(found.DistrictName);
        form.setFieldsValue({
          action_taken_police_station: found.DistrictName,
        });
      }
    }
  };
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      professionalService
        .getDistrict(user.cityId)
        .then((res) => {
          setDistricts(res?.pc_districts || []);
        })
        .catch((err) => {
          console.log("District API Error:", err);
        });
    }
  }, []);
  useEffect(() => {
    if (
      props.role === "2" &&
      districts &&
      districts.length &&
      user.districtId
    ) {
      getDistrictName();
    }
  }, [user.role, districts, user.districtId, form]);
  console.log("props", props);

  const [inputField, setInputField] = useState({
    sadyasthiti: "",
    aadhar_no: "",
    dob: "",
    atak_date: "",
    court_dateTime: "",
    option_system: "",
  });
  const getSadyasthiti = () => {
    professionalAction.getSadyasthiti().then((res) => {
      res && setSadyasthiti(res);
    });
  };

  useEffect(() => {
    getSadyasthiti();
  }, []);
  // useEffect(() => {
  //   if (props && props.sadyasthitiData) {
  //     setSadyasthiti(props.sadyasthitiData);
  //   }
  //   form.resetFields();
  // }, [props.newGunha]);

  useEffect(
    (res) => {
      if (
        props.editData &&
        props.editData.length &&
        props.editData[0].arrestInfo &&
        props.editData[0].arrestInfo.length
      ) {
        let ob = {
          ...props.editData[0].arrestInfo[0],
        };
        delete ob.date_from;
        delete ob.date_to;
        form.setFieldsValue({
          ...ob,
          arrest_dateTime:
            props.editData[0]?.arrestInfo[0] &&
            moment(props.editData[0]?.arrestInfo[0]?.arrest_dateTime),
          court_dateTime:
            props.editData[0]?.arrestInfo[0] &&
            moment(props.editData[0]?.arrestInfo[0]?.court_dateTime),
          criminal_dob: props.editData[0]?.arrestInfo[0]?.criminal_dob
            ? props.editData[0]?.arrestInfo[0] &&
              moment(
                parseDateAnyFormat(
                  props.editData[0]?.arrestInfo[0]?.criminal_dob,
                ),
              )
            : "",
          option_system:
            props.editData[0].arrestInfo &&
            props.editData[0].arrestInfo[0].option_system,
        });

        // IMAGE UPDATE ACCUSED IMAGE
        let accusedImageTemp =
          props.editData[0].arrestInfo[0].photo &&
          props.editData[0].arrestInfo[0].photo.length
            ? props.editData[0].arrestInfo[0].photo.split(",")
            : [];
        let accusedImage =
          accusedImageTemp &&
          accusedImageTemp.length &&
          accusedImageTemp.map((item, index) => {
            return {
              uid: index,
              name: item,
              status: "done",
              url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL + item,
            };
          });
        SetfileList(accusedImage && accusedImage ? accusedImage : []);
      } else {
        form.resetFields();
      }
    },
    [props.editData],
  );
  const disableFutureDates = (current) => {
    return current && current > moment().endOf("day");
  };
  function parseDateAnyFormat(dateStr) {
    dateStr = dateStr.trim();
    let dateObj = new Date(dateStr);
    if (!isNaN(dateObj)) return dateObj;
    dateStr = dateStr.replace(/[-.]/g, "/");
    const parts = dateStr.split(/[/\s,:]+/);
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        if (parseInt(parts[1]) > 12) {
          dateObj = new Date(`${parts[0]}/${parts[2]}/${parts[1]}`);
        } else {
          dateObj = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
        }
      } else if (parts[2].length === 4) {
        dateObj = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
      }
    } else if (parts.length === 6) {
      if (parts[0].length === 4) {
        dateObj = new Date(
          `${parts[0]}/${parts[1]}/${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      } else {
        dateObj = new Date(
          `${parts[2]}/${parts[1]}/${parts[0]} ${parts[3]}:${parts[4]}:${parts[5]}`,
        );
      }
    }
    return !isNaN(dateObj) ? dateObj : "Invalid Date";
  }

  const onFinish = async (values) => {
    try {
      let accusedImage = fileList && fileList.map((item) => item.name);

      let obj = {
        ...values,
        gunhaId: props.editData && props.editData[0].id,
        arrest_dateTime:
          values.arrest_dateTime && moment(values?.arrest_dateTime),
        court_dateTime: values.court_dateTime && moment(values?.court_dateTime),
        criminal_dob: values.criminal_dob
          ? moment(values?.criminal_dob).format("YYYY-DD-MM")
          : "",
        photo: accusedImage && accusedImage,
      };

      if (
        props?.editData?.length > 0 &&
        props?.editData[0]?.arrestInfo?.length > 0
      ) {
        await props.onArrestFormUpdate(obj, props?.editData[0]?.arrestInfo[0]);
      } else {
        await props.onArrestFormFiniesh(obj);
      }
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onFinish() {
      form.submit();
    },
  }));

  // function beforeUpload(file) {
  //   if (file) {
  //     const isJpgOrPng =
  //       file.type === "image/jpeg" || file.type === "image/png";
  //     if (!isJpgOrPng) {
  //       message.error("You can only upload JPG/PNG file!");
  //       return false;
  //     }
  //     const isLt2M = file.size / 1024 / 1024 < 2;
  //     if (!isLt2M) {
  //       message.error("Image size Larger than 2MB!");
  //       return false;
  //     }
  //     if (file.name) {
  //       const fileChecked_php = file.name.split(".php");
  //       if (fileChecked_php.length > 1) {
  //         message.error("Image can not upload malicious file!");
  //         return false;
  //       }
  //       const fileChecked_java = file.name.split(".java");
  //       if (fileChecked_java.length > 1) {
  //         message.error("Image can not upload malicious file!");
  //         return false;
  //       }
  //       const fileChecked_html = file.name.split(".html");
  //       if (fileChecked_html.length > 1) {
  //         message.error("Image can not upload malicious file!");
  //         return false;
  //       }
  //       const fileChecked_net = file.name.split(".net");
  //       if (fileChecked_net.length > 1) {
  //         message.error("Image can not upload malicious file!");
  //         return false;
  //       }
  //     }
  //     return isJpgOrPng && isLt2M;
  //   }
  // }
  function beforeUpload(file) {
    return new Promise((resolve, reject) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return reject(false);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image size must be less than 2MB!");
        return reject(false);
      }

      // 🔥 Magic number validation
      const reader = new FileReader();
      reader.onloadend = function (e) {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isJPEG = header.startsWith("ffd8ff");
        const isPNG = header === "89504e47";

        if (!isJPEG && !isPNG) {
          message.error("Invalid image file! Possible malicious file.");
          return reject(false);
        }

        resolve(true);
      };

      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  }

  const closeCropModal = () => {
    if (cropImageSrc) {
      URL.revokeObjectURL(cropImageSrc);
    }
    setCropModalVisible(false);
    setCropImageSrc("");
    setCropOriginalFile(null);
  };

  const finishCrop = (nextFile) => {
    cropResolveRef.current?.resolve(nextFile);
    cropResolveRef.current = null;
    closeCropModal();
  };

  const cancelCrop = () => {
    cropResolveRef.current?.reject(Upload.LIST_IGNORE);
    cropResolveRef.current = null;
    closeCropModal();
  };

  function beforeUploadAccusedPhoto(file) {
    return beforeUpload(file).then(() => {
      return new Promise((resolve, reject) => {
        cropResolveRef.current = { resolve, reject };
        setCropOriginalFile(file);
        setCropImageSrc(URL.createObjectURL(file));
        setCropModalVisible(true);
      });
    });
  }

  const handleUpload = ({ fileList }) => {};

  const handleRemoveAccusedImage = (file) => {
    let temp = fileList;
    let tempIndex = _.findIndex(fileList, file);
    temp && temp.length && temp.splice(tempIndex, 1);
    SetfileList([...temp]);
  };

  const uploadImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    new Compressor(file, {
      quality: 0.2,
      async success(result) {
        const fmData = new FormData();
        setProgress(0);
        const config = {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": `multipart/form-data; boundary=${fmData._boundary}`,
          },
          onUploadProgress: (event) => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            setProgress(percent);
            if (percent === 100) {
              setTimeout(() => setProgress(0), 1000);
            }
            onProgress({ percent: (event.loaded / event.total) * 100 });
          },
        };
        const newFileName = "pc_" + result.name;
        fmData.append("profileImage", result, newFileName);
        try {
          const res = await axios.post(
            baseUrl + "/imageupload/profile-img-upload",
            fmData,
            config,
          );
          if (res.data && res.data.error) {
            onError({ ...res.data.error });
          } else {
            SetfileList([
              ...fileList,
              {
                uid: "1",
                name: res.data.imageName,
                status: "done",
                url: process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL,
              },
            ]);
            onSuccess("Ok");
          }
        } catch (err) {
          const error = new Error("Some error");
          onError({ err });
        }
      },
      error(err) {
        console.log(err.message);
      },
    });
  };

  const onSadysthitiChange = (value) => {
    setSadysthitiValue(value);
  };

  const handleInputChange = async (event) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        ...authHeader(),
      };
      const response = await axios.post(
        `${baseUrl}/arrest/checkAadhar`,
        { aadharno: event.target.value },
        { headers },
      );
      if (!response.data.unique) {
        form.setFields([
          {
            name: "aadharno",
            errors: ["Aadhar number already exists!"],
          },
        ]);
      }
    } catch (error) {
      console.error("Error checking Aadhar:", error);
    }
  };
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (props?.editData[0]?.arrestInfo[0]?.arrest_dateTime) {
      setStartDate(props.editData[0]?.arrestInfo[0]?.arrest_dateTime);
    }
  }, [props?.editData]);

  const [defaultDate, setDefaultDate] = useState(null);
  const onYearChange = (date) => {
    if (date) {
      const arrestDateTime = moment(date);
      const nextDay = moment(arrestDateTime).add(1, "days");
      setStartDate(arrestDateTime);
      form.setFieldsValue({
        court_dateTime: nextDay,
      });
    } else {
      setStartDate(null);
      form.setFieldsValue({
        court_dateTime: null,
      });
    }
  };

  const disablePreviousDates = (current) => {
    if (!startDate) {
      return true;
    }
    return current && current < moment(startDate).add(1, "days").startOf("day");
  };
  const disableDateOfBithDates = (current) => {
    return current && current > moment().endOf("day");
  };
  function disabledDate(current) {
    if (!startDate) return true;
    return current && !current.isSame(moment(startDate), "year");
  }

  return (
    <div>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="sadyasthiti_id"
              label={t("current_status")}
              rules={[{ required: true, message: "Please select सदयस्थिति" }]}
            >
              <Select
                placeholder="Please select सदयस्थिति"
                onChange={onSadysthitiChange}
              >
                {sadyasthiti &&
                  sadyasthiti.length &&
                  sadyasthiti.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.title}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="aadharno"
              label={t("valid_aadhaar_number")}
              rules={[
                {
                  pattern: /^[1-9]\d{11}$/,
                  message:
                    "Aadhar Number must be a 12-digit number starting with 1-9",
                },
              ]}
              onChange={handleInputChange}
              maxLength={12} // Limit input to maximum 12 characters
              minLength={12}
            >
              <Input
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter आधार नंबर"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="criminal_dob"
              label={t("accused_dob")}
              // rules={[{ message: "Please enter आरोपीचा जन्म दिनांक" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={disableDateOfBithDates}
                inputReadOnly
              />
            </Form.Item>
          </Col>
          {props.role == "4" && (
            <Form.Item
              name="action_taken_police_station"
              label={t("action_taken_police_station")}
              rules={[{ required: true, message: "Please choose " }]}
            >
              <Select
                optionFilterProp="children"
                placeholder={t("action_taken_police_station")}
                onChange={(e) => setSelectDistricts(e)}
                value={selectDistricts}
              >
                {districts &&
                  districts.length > 0 &&
                  districts.map((res) => (
                    <Option key={res.id} value={res.DistrictName}>
                      {res.DistrictName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          )}
          {props.role == "2" && (
            <Form.Item
              name="action_taken_police_station"
              label={t("action_taken_police_station")}
              rules={[{ required: true }]}
            >
              <Input placeholder={t("action_taken_police_station")} disabled />
            </Form.Item>
          )}
        </Row>

        <Row gutter={18}>
          <Col span={9}>
            <Form.Item
              name="arrest_dateTime"
              label={t("arrest_datetime")}
              rules={[
                { required: true, message: "Please choose the कालावधी पासून" },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                onChange={onYearChange}
                defaultValue={startDate}
                disabledDate={disableFutureDates}
                inputReadOnly
              />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              name="court_dateTime"
              label={t("court_appearance_datetime")}
              rules={[
                {
                  required: true,
                  message: "Please choose the कोर्टात हजर दिनांक वेळ",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                disabled={!startDate}
                disabledDate={disablePreviousDates}
                inputReadOnly
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label={t("ambis_fingerprint_taken")}
              name="option_system"
              initialValue="0"
              rules={[{ required: true, message: "Please select option" }]}
            >
              <Select
                placeholder="Please select"
                //onChange={onPreventiveChange}
              >
                <Option value={"0"}> नाही</Option>
                <Option value={"1"}> होय</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={24}>
        <Col span={12} style={{ marginBottom: "30px" }}>
          <Upload
            accept="image/*"
            customRequest={uploadImage}
            fileList={fileList}
            onChange={handleUpload}
            beforeUpload={beforeUploadAccusedPhoto}
            onRemove={handleRemoveAccusedImage}
            maxCount={5}
          >
            <Button icon={<UploadOutlined />}>{t("add_accused_photo")}</Button>
          </Upload>
          <AccusedImageCropModal
            visible={cropModalVisible}
            imageSrc={cropImageSrc}
            fileName={cropOriginalFile?.name}
            mimeType={cropOriginalFile?.type}
            onCancel={cancelCrop}
            onApply={finishCrop}
            onUseOriginal={() => finishCrop(cropOriginalFile)}
          />
        </Col>
      </Row>
    </div>
  );
});
